import React, { useEffect, useState } from "react";
import { Button, Space, Table, Modal, Form, Input, message } from "antd";
import { UserAddOutlined, UserOutlined, MailTwoTone } from "@ant-design/icons";
import accountService from "../../services/account.service";

export default function Accounts() {
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = () => {
    accountService
      .getAllAccounts()
      .then((result) => {
        if (result.status === 200) {
          const mappedAccounts = result.data.map((account, index) => ({
            key: index,
            id: account.id,
            name: account.firstName + " " + account.lastName,
            email: account.email,
            username: account.username,
            playroom: account.playroom,
          }));
          setAccounts(mappedAccounts);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      title: "Ime",
      dataIndex: "name",
      key: "name",
      className: "text-base"
    },
    {
      title: "Igraonica",
      key: "action",
      className: "text-base",
      render: (account) => renderPlayroom(account.playroom),
    },
  ];

  const renderPlayroom = (playroom) => {
    if (!playroom) {
      return <span>Nema igraonicu</span>;
    }

    return (
      <div>
        <a href={`/playrooms/${playroom.id}`}>{playroom.name}</a>
      </div>
    );
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      console.log(values);
      await accountService.registerAccount(values);
      message.success("Uspješno je kreiran novi korisnik.");
      handleModalCancel();
      fetchAccounts();
    } catch (error) {
      message.error("Došlo je do greške pri kreiranju novog korisnika!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-6 py-6 overflow-auto h-screen">
      {" "}
      <div className="mb-4">
        <Space direction="vertical">
          <Button
            type="primary"
            size="large"
            icon={<UserAddOutlined />}
            style={{ paddingLeft: "10px" }}
            onClick={showModal}
          >
            Dodaj korisnika
          </Button>
          <div className="container mx-auto px-4 py-4">
            <Modal
              title="Dodaj korisnika"
              open={isModalOpen}
              onCancel={handleModalCancel}
              footer={[
                <Button key="cancel" onClick={handleModalCancel}>
                  Zatvori
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={() => form.submit()}
                >
                  Dodaj
                </Button>,
              ]}
              centered
            >
              <Form
                form={form}
                onFinish={handleSubmit}
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
                labelAlign="left"
                requiredMark={false}
                validateMessages={{
                  required: "Potrebno je popuniti sva polja",
                }}
              >
                <Form.Item
                  name="firstName"
                  label="Ime"
                  rules={[{ required: true, message: "Unesite ime korisnika" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="lastName"
                  label="Prezime"
                  rules={[
                    { required: true, message: "Unesite prezime korisnika" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Unesite email korisnika" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="username"
                  label="Username"
                  rules={[
                    {
                      required: true,
                      message: "Unesite korisničko ime korisnika",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Lozinka"
                  rules={[
                    {
                      required: true,
                      message: "Unesite podrazumijevanu lozinku korisnika",
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  label="Telefon"
                  rules={[
                    {
                      required: true,
                      message: "Unesite broj telefona korisnika",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </Space>
      </div>
      <div className="bg-white p-4 shadow rounded-lg">
        {" "}
        <Table
          columns={columns}
          expandable={{
            expandedRowRender: (account) => (
              <div className="flex flex-col space-y-2 p-4 bg-gray-50 rounded-lg">
                <p className="flex items-center space-x-2 text-gray-600 text-base">
                  <MailTwoTone />
                  <span className="font-medium">{account.email}</span>
                </p>
                <p className="flex items-center space-x-2 text-gray-600">
                  <UserOutlined />
                  <span className="font-medium">{account.username}</span>
                </p>
                <p className="flex items-center space-x-2 text-gray-600">
                  {/* <span className="font-medium">{record.packageName}</span> */}
                </p>
              </div>
            ),
            rowExpandable: () => true,
          }}
          dataSource={accounts}
        //   pagination={{
        //     current: pageNumber,
        //     pageSize: pageSize,
        //     showSizeChanger: false,
        //     total: totalItems,
        //   }}
        //   onChange={handleTableChange}
        />
      </div>
    </div>
  );
}
